<!-- <div>
  <tidy-text header="Add Action"></tidy-text>
</div> -->

<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    (click)="printForm()"
    [class]="extraClass"
    [title]="'Add Action'" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" (contentHeight)="contentHeight = $event" />
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
